import moment from 'moment';
import IntAssessHdrService from "@/service/IntAssessHdrService";
import { IntAssessHdr } from "@/model/IntAssessHdr";
import { IntAssessDtl } from "@/model/IntAssessDtl";
import SweetAlertService from "@/service/SweetAlertService";
import JobsService from "@/service/JobsService";
import StoreGetter from "@/constants/StoreGetter";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import DatePicker from "vue2-datepicker";
import interviewStartValidatonObj from "./S090300-InterviewStartValidaton.js";
var interviewStartDataValidatonObj = new interviewStartValidatonObj();
export default {
  name: "InterviewStart",
  props: ["candidateInvitedModel"],
  components: {
    DatePicker
  },
  mounted() {
    interviewStartDataValidatonObj.interviewStartValidaton();
    this.getAllStatus();
    this.getPayCycleType();
    this.getAllJob();
  },
  data: () => ({
    e1: 1,
    dictEnum: dictEnum,
    date: new Date(),
    activeTab: '',
    type: 'date',
    intAssessHdr: new IntAssessHdr(),
    intAssessDtl: new IntAssessDtl(),
    selectedAssessTemp: {
      Grp: "",
      Item: "",
      OptRadioList: []
    },
    jobCodeList: [],
    groupList: [],
    assessTempList: [],
    payCycleTypeList: [],
    statusList: [],
    IsViewMode: false,
    selectedAssessHdr: new IntAssessHdr(),
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    formattedDate() {
      return this.date &&
        moment(this.date).format('YYYY-MM-DD') != '1900-01-01'
        ? moment(this.date).format('YYYY-MM-DD')
        : undefined;
    },
  },
  methods: {
    async getAllJob() {
      var self = this;
      const obj = {};
      const response = await JobsService.getAllJobs(obj);
      if (response.data.IsSuccess) {
        self.jobCodeList = response.data.Data;
        self.selectedAssessHdr.CandID = self.candidateInvitedModel.CandID;
        self.selectedAssessHdr.JobAdCode = self.candidateInvitedModel.JobAdCode;
        self.selectedAssessHdr.Seq = Number(self.candidateInvitedModel.Seq);
        self.getIntAssessHdrDetail();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    changeInterview: function (seq) {
      var self = this;
      self.selectedAssessHdr = new IntAssessHdr();
      self.intAssessHdr = new IntAssessHdr();
      self.intAssessDtl = new IntAssessDtl();
      self.$validator.reset();
      self.vErrors.clear();
      self.selectedAssessHdr.CandID = self.candidateInvitedModel.CandID;
      self.selectedAssessHdr.JobAdCode = self.candidateInvitedModel.JobAdCode;
      self.selectedAssessHdr.Seq = Number(seq);
      self.getIntAssessHdrDetail();
    },
    async getAllStatus() {
      var self = this;
      const obj = {};
      const response = await IntAssessHdrService.getAllStatus(obj);
      if (response.data.IsSuccess) {
        var statusList = response.data.Data;
        if (statusList != null && statusList.length > 0) {
          self.statusList = statusList.filter(obj => obj.StatusCode == '30' || obj.StatusCode === '40' || obj.StatusCode === '50' || obj.StatusCode === '80');
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllAssessTemp() {
      var self = this;
      const obj = {};
      const response = await IntAssessHdrService.getAllAssessTemp(obj);
      if (response.data.IsSuccess) {
        response.data.Data = response.data.Data.filter((x) => x.Type == "INT")
        var groupList = response.data.Data.filter(
          obj => obj.Item == 0
        );
        self.groupList = groupList;
        self.activeTab = self.groupList[0].EDesc;
        self.selectedAssessTemp = self.groupList[0];
        var assessTempList = response.data.Data.filter(
          obj => obj.Item !== 0
        );
        if (self.intAssessHdr.IntAssessDtlList != null && self.intAssessHdr.IntAssessDtlList.length > 0 && assessTempList != null && assessTempList.length > 0) {
          assessTempList.forEach((element) => {
            var intAssessDtlDetail = self.intAssessHdr.IntAssessDtlList.find((obj) => obj.Grp == element.Grp && obj.Item == element.Item);
            if (intAssessDtlDetail != null && intAssessDtlDetail != undefined) {
              element.Ans = intAssessDtlDetail.Ans;
              element.Rem = intAssessDtlDetail.Rem;
            }
          }
          );
        }
        self.assessTempList = assessTempList;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getIntAssessHdrDetail() {
      var self = this;
      const obj = {
        candId: self.selectedAssessHdr.CandID,
        jobAdCode: self.selectedAssessHdr.JobAdCode,
        seq: self.selectedAssessHdr.Seq,
      };
      const response = await IntAssessHdrService.getIntAssessHdrDetail(obj);
      if (response.data.IsSuccess) {
        if (response.data.Data != null) {
          self.intAssessHdr.JobName = "";
          self.intAssessHdr = response.data.Data;
          if (self.intAssessHdr.DateCommence != null && self.intAssessHdr.DateCommence != "") {
            var dateCommence = moment(String(self.intAssessHdr.DateCommence)).format("YYYY-MM-DD");
            if (dateCommence == '1900-01-01') {
              self.intAssessHdr.DateCommence = moment().format("YYYY-MM-DD");
            }
            else {
              self.intAssessHdr.DateCommence = dateCommence;
            }
          }
          var jobCodeDetail = self.jobCodeList.find((obj) => obj.JobCode == self.intAssessHdr.JobCode);
          if (jobCodeDetail != null && jobCodeDetail != undefined) {
            self.intAssessHdr.JobName = self.user.Lang == 'EN' ? jobCodeDetail.EDesc : jobCodeDetail.CDesc;
          }
          if (Number(self.candidateInvitedModel.Seq) != Number(self.selectedAssessHdr.Seq)) {
            self.IsViewMode = true;
          }
          else {
            self.IsViewMode = false;
          }
          self.getAllAssessTemp();
        }
        else {
          self.resetData();
          self.$router.push(`/JobApplicationForm`);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getPayCycleType() {
      var self = this;
      const obj = {};
      const response = await IntAssessHdrService.getPayCycleType(obj);
      if (response.data.IsSuccess) {
        self.payCycleTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    onTabChange: function (data) {
      this.selectedAssessTemp = data;
      this.activeTab = data.EDesc;
    },
    changeRecommandation: function () {
      var self = this;
      if (self.intAssessHdr.IntStatus != '80') {
        self.intAssessHdr.JobCode = "";
        self.intAssessHdr.DateCommence = moment().format("YYYY-MM-DD");
        self.intAssessHdr.BasicSalary = "";
        self.intAssessHdr.SalPayCycle = "";
        self.intAssessHdr.Allw = "";
        self.intAssessHdr.PayCycle = "";
        self.intAssessHdr.JobName = "";
      }
    },
    OnJobCodeBtnClick: function () {
      $("#jobCodeModel").modal("show");
    },
    OnJobCodeSelect: function (model) {
      var self = this;
      self.intAssessHdr.JobCode = model.JobCode;
      var jobName = self.user.Lang == 'EN' ? model.EDesc : model.CDesc;
      self.intAssessHdr.JobName = model.JobCode + "-" + jobName;
      $("#jobCodeModel").modal("hide");
    },
    //Interview Start Method
    submitIntAssessPopup: function () {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.intAssessHdr.IntAssessDtlList = [];
          self.assessTempList.forEach((value) => {
            if (value.AnsType == 'RAD') {
              if (value.Ans != '') {
                self.intAssessDtl = new IntAssessDtl();
                self.intAssessDtl.CandID = self.candidateInvitedModel.CandID;
                self.intAssessDtl.JobAdCode = self.candidateInvitedModel.JobAdCode;
                self.intAssessDtl.Seq = Number(self.candidateInvitedModel.Seq);
                self.intAssessDtl.Grp = value.Grp;
                self.intAssessDtl.Item = value.Item;
                self.intAssessDtl.Ans = value.Ans;
                self.intAssessDtl.Rem = value.Rem;
                self.intAssessHdr.IntAssessDtlList.push(self.intAssessDtl);
              }
            }
          });
          if (self.intAssessHdr.IntAssessDtlList.length > 0) {
            $('#submitInterviewModel').modal('show');
          }
          else {
            SweetAlertService.warning("Warn", self.t.t(dictEnum.WARN_FillInformation));
          }
        }
        else {
          SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_ValidationFailed));
        }
      });
    },
    closeIntAssessPopup: function () {
      var self = this;
      $('#submitInterviewModel').modal('hide');
    },
    async saveIntAssessHdrData() {
      var self = this;
      $('#submitInterviewModel').modal('hide');
      self.intAssessHdr.CandID = self.candidateInvitedModel.CandID;
      self.intAssessHdr.JobAdCode = self.candidateInvitedModel.JobAdCode;
      self.intAssessHdr.Seq = Number(self.candidateInvitedModel.Seq);
      if (self.intAssessHdr.DateCommence != null && self.intAssessHdr.DateCommence != "" && self.intAssessHdr.IntStatus == '80') {
        self.intAssessHdr.DateCommence = moment(String(self.intAssessHdr.DateCommence)).format("YYYY-MM-DD");
      }
      else {
        self.intAssessHdr.DateCommence = '1900-01-01';
      }
      if (self.intAssessHdr.DateInt != null && self.intAssessHdr.DateInt != "") {
        self.intAssessHdr.DateInt = moment(String(self.intAssessHdr.DateInt)).format("YYYY-MM-DD HH:mm");
      }
      else {
        self.intAssessHdr.DateInt = '1900-01-01 00:00';
      }
      self.intAssessHdr.BasicSalary = Number(self.intAssessHdr.BasicSalary);
      self.intAssessHdr.Allw = Number(self.intAssessHdr.Allw);
      self.intAssessHdr.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
      self.intAssessHdr.AddBy = self.$store.getters[StoreGetter.user].UserID;
      self.intAssessHdr.IntAssessLogModel.CandID = self.intAssessHdr.CandID;
      self.intAssessHdr.IntAssessLogModel.JobAdCode = self.intAssessHdr.JobAdCode;
      self.intAssessHdr.IntAssessLogModel.Seq = Number(self.intAssessHdr.Seq);
      self.intAssessHdr.IntAssessLogModel.IntStatus = self.intAssessHdr.IntStatus;
      self.intAssessHdr.IntAssessLogModel.LogBy = self.$store.getters[StoreGetter.user].UserID;
      var obj = {
        model: self.intAssessHdr,
      }
      self.saveIntAssessHdr(obj);
    },
    async saveIntAssessHdr(obj) {
      var self = this;
      const response = await IntAssessHdrService.saveIntAssess(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", self.t.t(dictEnum.MSG_InterviewSubmit));
        self.resetData();
        self.$router.push(`/JobApplicationForm`);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    resetData: function () {
      var self = this;
      self.IsViewMode = false;
      self.selectedAssessHdr = new IntAssessHdr();
      self.intAssessHdr = new IntAssessHdr();
      self.intAssessDtl = new IntAssessDtl();
      self.$validator.reset();
      self.vErrors.clear();
      self.$store.dispatch({
        type: "IntAssessHdrStore/refershIntAssessHdr",
        payload: {}
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090300-JobInterviewStart/S090300-InterviewStart/S090300-InterviewStart.js